<template>
  <div>
    <BaseTitle
      :title="$t(isEditable ? 'content.template_e_rapor_view' : edit ? 'content.template_e_rapor_edit' : 'content.template_e_rapor_create')"
    />
    <v-row>
      <v-col cols="12" md="12">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <form-group :name="$t('content.template_name')" :validator="$v.form.name">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.name"
                    :disabled="isEditable"
                    v-bind="attrs"
                    :label="$t('content.template_name')"
                    @input="$v.form.name.$touch()"
                    @blur="$v.form.name.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title">{{ $t('content.rule_rapor') }}</div>
              <v-row>
                <!-- <v-col md="4">
                  <form-group :name="$t('content.extracurricular')" :validator="$v.form.extracurricular">
                    <template slot-scope="{ attrs }">
                      <v-checkbox
                        v-bind="attrs"
                        :disabled="isEditable"
                        color="secondary"
                        v-model="form.extracurricular"
                        :label="$t('content.extracurricular')"
                      />
                    </template>
                  </form-group>
                </v-col> -->
                <v-col md="4">
                  <form-group :name="$t('content.achievement')" :validator="$v.form.achievement"
                    ><template slot-scope="{ attrs }">
                      <v-checkbox
                        v-bind="attrs"
                        :disabled="isEditable"
                        color="secondary"
                        v-model="form.achievement"
                        :label="$t('content.achievement')"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <div class="d-flex justify-start ">
            <v-btn
              color="primary"
              class="btn-primary-custom"
              :disabled="isEditable"
              v-if="statusPoint === false"
              @click="statusPoint = true"
              :loading="loading"
            >
              {{ $t('content.add_point_course') }}
            </v-btn>
          </div>

          <!-- add point course -->
          <v-card class="mb-8" v-if="statusPoint === true">
            <div class="pa-8">
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('content.course_name')" :validator="$v.formTemp.courseName">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="formTemp.courseName"
                        @input="duplicateCourse($event)"
                        :disabled="isEditable"
                        v-bind="attrs"
                        :label="$t('content.course_name')"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <form-group :name="$t('content.minimum_criteria')" :validator="$v.formTemp.minimumCriteria">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="formTemp.minimumCriteria"
                        type="number"
                        :disabled="isEditable"
                        v-bind="attrs"
                        :label="$t('content.minimum_criteria')"
                        v-number
                        @paste="onPaste"
                        :min="0"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('content.group_report')" :validator="$v.formGroup.name">
                    <template slot-scope="{ attrs }">
                      <v-text-field v-model="formGroup.name" :disabled="isEditable" v-bind="attrs" :label="$t('content.group_report')" />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <v-btn color="primary" class="btn-primary-custom" @click="createGroup" :loading="loadingGroup">
                    {{ $t('table.create') }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- group -->
              <div class="pa-5 card-radio mb-6">
                <v-radio-group v-model="formTemp.eraporGroupId" row vertical>
                  <v-radio v-for="(data, index) in listGroup" color="secondary" :key="index" @change="changeGroup(data)" :value="data.eraporGroupId">
                    <template v-slot:label>
                      <div class="d-flex d-inline">
                        <span class="mr-6 mt-1">
                          {{ data.name }}
                        </span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <span dark v-bind="attrs" v-on="on">
                              <svg-icon icon="ic-moreaction-black" class="mt-1" />
                            </span>
                          </template>
                          <v-list>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown" @click="goEditGroup(data)">{{ $t('edit') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown-delete" @click="onDeleteGroupItem(data.eraporGroupId)">{{
                                $t('table.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <NoData v-if="!listGroup.length" />
              </div>
              <!-- Dialog Edit Group -->
              <v-dialog v-model="dialogPopUpGroup" persistent max-width="800">
                <v-card>
                  <v-card-title class="headline secondary white--text d-flex justify-space-between">
                    <span>{{ $t('content.edit_grup') }}</span>
                  </v-card-title>
                  <v-card-subtitle class="pa-10">
                    <v-row>
                      <v-col cols="12" md="12" class="py-0">
                        <form-group :name="$t('content.group_report')" :validator="$v.dataEditGroup.name">
                          <template slot-scope="{ attrs }">
                            <v-text-field v-model="dataEditGroup.name" :disabled="isEditable" v-bind="attrs" :label="$t('content.group_report')" />
                          </template>
                        </form-group>
                      </v-col>
                    </v-row>
                  </v-card-subtitle>
                  <v-card-actions>
                    <v-spacer />
                    <div class="d-flex justify-end align-center mb-2 mr-2">
                      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closePopupGroup">{{ $t('back') }}</v-btn>
                      <v-btn color="primary" class="btn-primary-custom" type="submit" :loading="loadingGroup" @click="createGroup">{{
                        $t('submit')
                      }}</v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Dialog Delete Group -->
              <v-dialog v-model="dialogDelete" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                  <v-card-text>{{ $t('delete_message') }}</v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
                    <v-btn text :loading="loading" @click="deleteGroupItem">{{ $t('aggree') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- predicate -->
              <v-row>
                <v-col md="2">
                  <div class="app-section-title mb-6">{{ $t('content.predicate') }}</div>
                </v-col>
                <v-col md="2">
                  <v-btn color="primary" class="btn-primary-custom" @click="addPredicate" :loading="loadingGroup">
                    {{ $t('add') }}
                  </v-btn>
                </v-col>
              </v-row>
              <div class="pa-5 card-radio mb-6">
                <v-row v-for="(predicates, index) in formTemp.eraporPredicates" color="secondary" :key="index">
                  <v-col md="3">
                    <form-group :name="$t('content.predicate')" :validator="$v.formTemp.eraporPredicates.$each.$iter[index].gradeName">
                      <template slot-scope="{ attrs }">
                        <v-select
                          v-model="predicates.gradeName"
                          v-bind="attrs"
                          :items="predicate"
                          :label="$t('content.predicate')"
                          @blur="$v.formTemp.eraporPredicates.$each.$iter[index].gradeName.$touch()"
                        />
                      </template>
                    </form-group>
                  </v-col>
                  <v-col md="2">
                    <form-group :name="$t('content.max_value')" :validator="$v.formTemp.eraporPredicates.$each.$iter[index].maxValue">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          v-model="predicates.maxValue"
                          @blur="$v.formTemp.eraporPredicates.$each.$iter[index].maxValue.$touch()"
                          :min="0"
                          type="number"
                          v-number
                          v-bind="attrs"
                          :label="$t('content.max_value')"
                          @input="minimum($event, index)"
                          @paste="onPaste"
                        />
                      </template>
                    </form-group>
                  </v-col>
                  <v-col md="2">
                    <form-group :name="$t('content.min_value')" :validator="$v.formTemp.eraporPredicates.$each.$iter[index].minValue">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          v-model="predicates.minValue"
                          @blur="$v.formTemp.eraporPredicates.$each.$iter[index].minValue.$touch()"
                          :max="predicates.maxValue"
                          type="number"
                          v-number
                          v-bind="attrs"
                          :min="0"
                          :disabled="!predicates.maxValue"
                          :label="$t('content.min_value')"
                          @input="maximum($event, index)"
                          @paste="onPaste"
                        />
                      </template>
                    </form-group>
                  </v-col>
                  <v-col md="3">
                    <form-group :name="$t('form.desc')" :validator="$v.formTemp.eraporPredicates.$each.$iter[index].description">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          v-model="predicates.description"
                          @blur="$v.formTemp.eraporPredicates.$each.$iter[index].description.$touch()"
                          v-bind="attrs"
                          :label="$t('form.desc')"
                        />
                      </template>
                    </form-group>
                  </v-col>
                  <v-col md="2" class="d-flex justify-center">
                    <v-btn color="red" outlined @click="deletePredicate(index)" class="btn-primary-custom mt-2">
                      {{ $t('table.delete') }}
                    </v-btn>
                  </v-col>
                </v-row>
                <NoData v-if="!formTemp.eraporPredicates.length" />
              </div>
              <div class="app-section-title mb-6">{{ $t('form.desc') }}</div>
              <form-group :name="$t('form.desc')" :validator="$v.formTemp.description">
                <template slot-scope="{ attrs }">
                  <text-editor v-bind="attrs" v-model="formTemp.description" />
                </template>
              </form-group>
            </div>
            <div class="d-flex justify-end align-center pa-5">
              <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="cancelPointCourse">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" class="btn-primary-custom" :loading="loading" @click="addPointCourse">
                {{ Number.isInteger(keyPredicate) ? $t('edit') : $t('add') }}
              </v-btn>
            </div>
          </v-card>

          <v-divider class="mt-6 mb-6" v-if="statusPoint === false" />

          <!-- list point course -->
          <div v-if="statusPoint === false">
            <v-card class="mb-5" v-for="(eraporGroupTemplates, indexParent) in form.eraporGroupTemplates" :key="indexParent">
              <slide-box :value="true">
                <template #activator="{isOpen}">
                  <div class="pa-5 d-flex justiy-space-between align-items section-header active">
                    <div class="student-title">{{ eraporGroupTemplates.name }}</div>
                    <v-spacer />
                    <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                  </div>
                </template>
                <template>
                  <div class="assignment-content pa-3">
                    <v-data-table
                      :headers="tableHeader"
                      :items="eraporGroupTemplates.eraporTemplateCourses"
                      :server-items-length="eraporGroupTemplates.eraporTemplateCourses.length"
                      hide-default-footer
                      disable-pagination
                      class="table-custom"
                    >
                      <template #item.description="{ item }">
                        <article class="container " v-html="item.description" />
                      </template>
                      <template #item.eraporPredicates="{ item }">
                        <ul>
                          <li v-for="(datas, index) in item.eraporPredicates" :key="index">
                            {{ datas.gradeName }} {{ datas.maxValue }} - {{ datas.minValue }} {{ datas.description }}
                          </li>
                        </ul>
                      </template>
                      <template #item.actions="{ item }" v-if="!isEditable">
                        <v-btn text @click="dialogDeleteCourse = true" class="mr-1"><svg-icon icon="delete" small class="red--text"/></v-btn>
                        <v-btn
                          text
                          @click="editItemCouse(item, eraporGroupTemplates.eraporTemplateCourses.indexOf(item), eraporGroupTemplates, indexParent)"
                          ><svg-icon icon="edit" small class="primary--text"
                        /></v-btn>
                        <!-- Dialog Delete Course -->
                        <v-dialog v-model="dialogDeleteCourse" persistent max-width="290">
                          <v-card>
                            <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                            <v-card-text>{{ $t('delete_message') }}</v-card-text>
                            <v-card-actions>
                              <v-spacer />
                              <v-btn text @click="dialogDeleteCourse = false">{{ $t('disagree') }}</v-btn>
                              <v-btn
                                text
                                :loading="loading"
                                @click="deleteItemCourse(eraporGroupTemplates.eraporTemplateCourses.indexOf(item), indexParent)"
                                >{{ $t('aggree') }}</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </template>

                      <template #no-data><NoData /></template>
                      <template #loading>
                        <img src="@/assets/images/globe.gif" class="pa-4" />
                      </template>
                    </v-data-table>
                  </div>
                </template>
              </slide-box>
            </v-card>

            <div class="d-flex justify-end align-center" v-if="form.eraporGroupTemplates.length > 0">
              <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" class="btn-primary-custom" v-if="!isEditable" @click="submit" :loading="loading">
                {{ $t('submit') }}
              </v-btn>
            </div>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import NoData from '@/components/table/NoData';
import SlideBox from '@/components/SlideBox';
import TextEditor from '@/components/base/TextEditor.vue';
import { maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'CreateEditTemplate',
  components: {
    BaseTitle,
    SlideBox,
    NoData,
    TextEditor
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        name: { required },
        // extracurricular: { required },
        achievement: { required }
      },
      formTemp: {
        name: { required },
        eraporGroupId: { required },
        courseName: { required, maxLength: maxLength(30) },
        minimumCriteria: { required },
        description: { required },
        eraporPredicates: {
          ...{ required },
          $each: {
            gradeName: { required },
            maxValue: { required },
            minValue: { required },
            description: { required, maxLength: maxLength(60) }
          }
        }
      },
      formGroup: {
        name: { required }
      },
      dataEditGroup: {
        name: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeader() {
      return [
        { text: this.$t('content.course_name'), value: 'courseName', sortable: false },
        { text: this.$t('content.minimum_criteria'), value: 'minimumCriteria', sortable: false },
        { text: this.$t('content.predicate'), value: 'eraporPredicates', sortable: false },
        { text: this.$t('form.desc'), value: 'description', sortable: false },
        { text: '', value: 'actions', sortable: false }
      ];
    }
  },
  data: () => ({
    form: {
      name: '',
      // extracurricular: false,
      achievement: false,
      eraporGroupTemplates: []
    },
    formTemp: {
      name: '',
      eraporGroupId: '',
      courseName: '',
      minimumCriteria: '',
      description: '',
      eraporPredicates: []
    },
    formGroup: {
      name: ''
    },
    listGroup: [],
    eraporPredicates: [],
    keyPredicate: '',
    keyChild: '',
    statusPoint: false,
    loadingButton: false,
    loadingGroup: false,
    loading: false,
    edit: false,
    currentItemGroup: '',
    dialogDelete: false,
    dialogPopUpGroup: false,
    dialogDeleteCourse: false,
    dataEditGroup: {
      eraporGroupId: '',
      name: ''
    },
    predicate: [
      { value: 'A', text: 'A' },
      { value: 'B', text: 'B' },
      { value: 'C', text: 'C' },
      { value: 'D', text: 'D' },
      { value: 'E', text: 'E' }
    ]
  }),
  methods: {
    onPaste(evt) {
      if (evt) {
        evt.preventDefault();
      }
    },
    duplicateCourse(e) {
      this.form.eraporGroupTemplates.forEach(datas => {
        datas.listCourseName = datas.eraporTemplateCourses.reduce((acc, row) => {
          acc.push(row.courseName);
          return acc;
        }, []);
      });
      var courseParent = [];
      for (var v of this.form.eraporGroupTemplates) {
        courseParent.push(...v.listCourseName);
      }
      let arrCourse = courseParent;
      if (arrCourse.includes(e)) {
        this.formTemp.courseName = '';
      }
    },
    duplicate(e, index) {
      function hasDuplicates(arr) {
        var counts = [];

        for (var i = 0; i <= arr.length; i++) {
          if (counts[arr[i]] === undefined) {
            counts[arr[i]] = 1;
          } else {
            return true;
          }
        }
        return false;
      }
      let arrDup = this.formTemp.eraporPredicates.reduce((acc, row) => {
        acc.push(row.gradeName);
        return acc;
      }, []);
      const result = arrDup.filter(as => as);
      if (hasDuplicates(result)) {
        this.$nextTick(() => {
          this.formTemp.eraporPredicates[index].gradeName = '';
        });
      }
      this.$v.formTemp.eraporPredicates.$each.$iter[index].gradeName.$touch();
    },
    maximum(e, index) {
      if (Number(e) >= Number(this.formTemp.eraporPredicates[index].maxValue)) {
        this.$nextTick(() => {
          this.formTemp.eraporPredicates[index].minValue = this.formTemp.eraporPredicates[index].maxValue - 1;
        });
      }
      this.$v.formTemp.eraporPredicates.$each.$iter[index].minValue.$touch();
    },
    minimum(e, index) {
      if (index !== 0) {
        if (Number(e) >= Number(this.formTemp.eraporPredicates[index - 1].minValue)) {
          this.$nextTick(() => {
            if (this.formTemp.eraporPredicates[index - 1].minValue === 0) {
              this.formTemp.eraporPredicates[index].maxValue = this.formTemp.eraporPredicates[index - 1].minValue;
            } else {
              this.formTemp.eraporPredicates[index].maxValue = this.formTemp.eraporPredicates[index - 1].minValue - 1;
            }
          });
        }
        this.$v.formTemp.eraporPredicates.$each.$iter[index].maxValue.$touch();
      }
    },
    getData() {
      this.$store.dispatch('TemplateErapor/fetchDetail', this.user.roleId !== 2 ? this.$route.params.id : this.$route.params.idTemplate).then(ras => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
      });
    },
    getDataGroup() {
      this.$store.dispatch('TemplateErapor/fetchListGroup').then(ras => {
        this.listGroup = ras;
      });
    },
    createGroup() {
      if (this.dataEditGroup.eraporGroupId ? this.$v.dataEditGroup.$invalid : this.$v.formGroup.$invalid) {
        this.dataEditGroup.eraporGroupId ? this.$v.dataEditGroup.$touch() : this.$v.formGroup.$touch();
        return false;
      }
      const dibagi = this.dataEditGroup.eraporGroupId ? this.dataEditGroup : this.formGroup;
      this.loadingGroup = true;
      const payload = { ...(this.dataEditGroup.eraporGroupId ? { id: this.dataEditGroup.eraporGroupId } : null), ...dibagi };

      this.$store
        .dispatch(`TemplateErapor/${this.dataEditGroup.eraporGroupId ? 'updateGroup' : 'createGroup'}`, payload)
        .then(data => {
          this.dialogPopUpGroup = false;
          this.formGroup.name = '';
          this.$v.formGroup.$reset();
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getDataGroup();
        })
        .finally(() => (this.loadingGroup = false));
    },
    addPredicate() {
      let maxValue;
      if (this.formTemp.eraporPredicates.length !== 0 && this.formTemp.eraporPredicates[this.formTemp.eraporPredicates.length - 1].minValue > 0) {
        maxValue = this.formTemp.eraporPredicates[this.formTemp.eraporPredicates.length - 1].minValue - 1;
      } else {
        maxValue = 0;
      }
      this.formTemp.eraporPredicates.push({
        gradeName: '',
        maxValue: maxValue,
        minValue: 0,
        description: ''
      });
    },
    changeGroup(data) {
      this.formTemp.name = data.name;
    },
    closePopupGroup() {
      this.formGroup.name = '';
      this.dataEditGroup = '';
      this.dialogPopUpGroup = false;
      this.$v.dataEditGroup.$reset();
    },
    goEditGroup(data) {
      this.dataEditGroup.eraporGroupId = data.eraporGroupId;
      this.dataEditGroup.name = data.name;
      this.dialogPopUpGroup = true;
    },
    deletePredicate(item) {
      this.formTemp.eraporPredicates.splice(item, 1);
    },
    addPointCourse() {
      if (!this.formTemp.description) {
        this.$store.dispatch('general/showErrorNotification', { message: 'Description Required' });
      }
      if (this.formTemp.eraporPredicates.length === 0) {
        this.$store.dispatch('general/showErrorNotification', { message: 'Predicate Required' });
      }
      if (!this.formTemp.eraporGroupId) {
        this.$store.dispatch('general/showErrorNotification', { message: 'Erapor Group Required' });
      }

      this.$v.formTemp.$touch();
      if (this.$v.formTemp.$invalid) {
        return false;
      }

      var index = this.form.eraporGroupTemplates.map(item => item.eraporGroupId).indexOf(this.formTemp.eraporGroupId);

      if (Number.isInteger(this.keyPredicate)) {
        if (this.formTemp.eraporGroupId === this.form.eraporGroupTemplates[this.keyPredicate].eraporGroupId) {
          this.form.eraporGroupTemplates[this.keyPredicate].eraporGroupId = this.formTemp.eraporGroupId;
          this.form.eraporGroupTemplates[this.keyPredicate].name = this.formTemp.name;
          this.form.eraporGroupTemplates[this.keyPredicate].eraporTemplateCourses[this.keyChild].courseName = this.formTemp.courseName;
          this.form.eraporGroupTemplates[this.keyPredicate].eraporTemplateCourses[this.keyChild].minimumCriteria = this.formTemp.minimumCriteria;
          this.form.eraporGroupTemplates[this.keyPredicate].eraporTemplateCourses[this.keyChild].description = this.formTemp.description;
          this.form.eraporGroupTemplates[this.keyPredicate].eraporTemplateCourses[this.keyChild].eraporPredicates = this.formTemp.eraporPredicates;
        } else {
          if (index === -1) {
            this.form.eraporGroupTemplates.push({
              eraporGroupId: this.formTemp.eraporGroupId,
              name: this.formTemp.name,
              eraporTemplateCourses: [
                {
                  courseName: this.formTemp.courseName,
                  minimumCriteria: this.formTemp.minimumCriteria,
                  description: this.formTemp.description,
                  eraporPredicates: this.formTemp.eraporPredicates
                }
              ]
            });
          } else {
            this.form.eraporGroupTemplates[index].eraporGroupId = this.formTemp.eraporGroupId;
            this.form.eraporGroupTemplates[index].name = this.formTemp.name;
            this.form.eraporGroupTemplates[index].eraporTemplateCourses.push({
              courseName: this.formTemp.courseName,
              minimumCriteria: this.formTemp.minimumCriteria,
              description: this.formTemp.description,
              eraporPredicates: this.formTemp.eraporPredicates
            });
          }
          this.form.eraporGroupTemplates[this.keyPredicate].eraporTemplateCourses.splice(this.keyChild, 1);
          if (this.form.eraporGroupTemplates[this.keyPredicate].eraporTemplateCourses.length === 0) {
            this.form.eraporGroupTemplates.splice(this.keyPredicate, 1);
          }
        }
      } else {
        if (index === -1) {
          this.form.eraporGroupTemplates.push({
            eraporGroupId: this.formTemp.eraporGroupId,
            name: this.formTemp.name,
            eraporTemplateCourses: [
              {
                courseName: this.formTemp.courseName,
                minimumCriteria: this.formTemp.minimumCriteria,
                description: this.formTemp.description,
                eraporPredicates: this.formTemp.eraporPredicates
              }
            ]
          });
        } else {
          this.form.eraporGroupTemplates[index].eraporGroupId = this.formTemp.eraporGroupId;
          this.form.eraporGroupTemplates[index].name = this.formTemp.name;
          this.form.eraporGroupTemplates[index].eraporTemplateCourses.push({
            courseName: this.formTemp.courseName,
            minimumCriteria: this.formTemp.minimumCriteria,
            description: this.formTemp.description,
            eraporPredicates: this.formTemp.eraporPredicates
          });
        }
      }

      this.$v.formTemp.$reset();
      this.statusPoint = false;
      this.formTemp.eraporGroupId = '';
      this.formTemp.courseName = '';
      this.formTemp.minimumCriteria = '';
      this.formTemp.description = '';
      this.formTemp.eraporPredicates = [];
      this.keyPredicate = '';
      this.keyChild = '';
    },
    cancelPointCourse() {
      this.$v.formTemp.$reset();
      this.statusPoint = false;
      this.formTemp.eraporGroupId = '';
      this.formTemp.courseName = '';
      this.formTemp.minimumCriteria = '';
      this.formTemp.description = '';
      this.formTemp.eraporPredicates = [];
      this.keyPredicate = '';
      this.keyChild = '';
    },
    deleteItemCourse(key, parent) {
      this.form.eraporGroupTemplates[parent].eraporTemplateCourses.splice(key, 1);
      if (this.form.eraporGroupTemplates[parent].eraporTemplateCourses.length === 0) {
        this.form.eraporGroupTemplates.splice(parent, 1);
      }
      this.dialogDeleteCourse = false;
    },
    editItemCouse(item, key, eraporGroupTemplates, indexParent) {
      this.formTemp.eraporGroupId = eraporGroupTemplates.eraporGroupId;
      this.formTemp.name = eraporGroupTemplates.name;
      this.formTemp.minimumCriteria = item.minimumCriteria;
      this.formTemp.description = item.description;
      this.formTemp.eraporPredicates = item.eraporPredicates;
      this.formTemp.courseName = item.courseName;

      this.keyPredicate = indexParent;
      this.keyChild = key;
      this.statusPoint = true;
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }
      if (this.form.eraporGroupTemplates.length > 0) {
        const input = this.form;

        this.loading = true;
        const payload = { ...(this.edit ? { id: this.user.roleId !== 2 ? this.$route.params.id : this.$route.params.idTemplate } : null), ...input };

        this.$store
          .dispatch(`TemplateErapor/${this.edit ? 'updateTemplate' : 'saveTemplate'}`, payload)
          .then(() =>
            this.$router.push({
              name:
                this.edit && this.user.roleId !== 2
                  ? 'eRaporTemplateUpdateSuccess'
                  : !this.edit && this.user.roleId !== 2
                  ? 'eRaporTemplateSuccess'
                  : this.edit && this.user.roleId === 2
                  ? 'eRaporTemplateSchoolAdminUpdateSuccess'
                  : 'eRaporTemplateSchoolAdminSuccess'
            })
          )
          .finally(() => (this.loading = false));
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: 'Point Course Not Found' });
      }
    },
    back() {
      if (this.user.roleId !== 2) {
        this.$router.push({ name: 'eRaporTemplateIndex' });
      } else {
        this.$router.push({ name: 'eRaporTemplateSchoolAdminIndex' });
      }
    },
    onDeleteGroupItem(item) {
      this.dialogDelete = true;
      this.currentItemGroup = item;
    },
    deleteGroupItem() {
      if (!this.currentItemGroup) return false;
      this.loading = true;
      this.$store
        .dispatch('TemplateErapor/destroyGroup', this.currentItemGroup)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItemGroup = null;
          this.getDataGroup();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.getDataGroup();
    if (this.$route.params.id && this.user.roleId !== 2) {
      this.getData();
      this.edit = true;
    } else if (this.$route.params.idTemplate && this.user.roleId === 2) {
      this.getData();
      this.edit = true;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
.card-radio {
  background-color: #b2ebd0;
  border-radius: 8px;
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
</style>
